<div mat-dialog-title role="heading" style="display: flex;">
  <div style="width: 50%; display: flex; flex-direction: column; justify-content: center;">
    <span>Access History</span>
  </div>

</div>
<mat-dialog-content style="padding-top: 0px !important;">
  <div style="width:800px;min-height: 300px;">
    <mat-table #table [dataSource]="dataSource" multiTemplateDataRows matSortDisableClear matSort id="SDAHTable"
      matSortActive="FirstName" matSortDirection="desc" aria-label="Student Document Access History Table">

      <ng-container matColumnDef="FirstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="FirstName">
          <span translate>First Name</span>
          <filter [data]="dataSource" columnName="FirstName" dataType="string" id="FirstNameFilter" class="mat-filter">
          </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.FirstName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="LastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="LastName">
          <span translate>Last Name</span>
          <filter [data]="dataSource" columnName="LastName" dataType="string" id="LastNameFilter" class="mat-filter">
          </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.LastName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="MiddleName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="MiddleName">
          <span translate>Middle Name</span>
          <filter [data]="dataSource" columnName="MiddleName" dataType="string" id="MiddleNameFilter"
            class="mat-filter">
          </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.MiddleName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="TimeStamp">
        <mat-header-cell *matHeaderCellDef mat-sort-header="TimeStamp">
          <span translate>Time Stamp</span>
          <filter [data]="dataSource" columnName="TimeStamp" dataType="string" id="TimeStampOnFilter" class="mat-filter">
          </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.TimeStamp | date: 'MM/dd/yy hh:mm a'}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="SDAHHeader">
      </mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="bltDataRow{{i}}" tabindex="0"
        style="padding:0px;overflow: hidden;" matRipple>
      </mat-row>
    </mat-table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>
  </div>
  <div class='flex-footer-right'>
    <div>
      <tyl-button image="cancel.png" label="Close" (clickEvent)="cancelClick()"></tyl-button>
    </div>
  </div>
</mat-dialog-actions>
